var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-user-component",
      on: {
        click: function ($event) {
          _vm.notice_modal_show = true
        },
      },
    },
    [
      _c("div", { staticClass: "broascast-box flex flex-center-1" }, [
        _c("div", { staticClass: "c-broadcast swiper-container" }, [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.notices, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "broadcast-item swiper-slide flex flex-ver",
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/icons/dianshiji.png"),
                      alt: "",
                    },
                  }),
                  _c("span", {
                    staticClass: "text text-overflow",
                    domProps: { innerHTML: _vm._s(item.notice) },
                  }),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }